const CASH_NEEDED = {
    LAWYER_FEE:      'lawyerFee',
    TITLE_INSURANCE: 'titleInsurance',
    HOME_INSPECTION: 'homeInspection',
    APPRAISAL_FEE:   'appraisalFee',
    ESTOPPEL_FEE:    'estoppelFee',
};

const CASH_NEEDED_DEFAULT_VALUES = {
    [CASH_NEEDED.LAWYER_FEE]:      1000,
    [CASH_NEEDED.TITLE_INSURANCE]: 900,
    [CASH_NEEDED.HOME_INSPECTION]: 500,
    [CASH_NEEDED.APPRAISAL_FEE]:   300,
    [CASH_NEEDED.ESTOPPEL_FEE]:    null,
};

export { CASH_NEEDED };
export default CASH_NEEDED_DEFAULT_VALUES;
